import React, {useState, useEffect, Fragment} from 'react'
import flatstore from 'flatstore';
import Loader from '../../../components/ui/Loader';
import LoadModules from '../../../components/ui/LoadModules'
import {getMeatcutSync} from '../../../utils/services';
import Meta from '../../../components/ui/Meta';
import { currentLang } from '../../../utils/functions';
import NotFound from '../404';
import parse from 'html-react-parser';
import Image from '../../../components/ui/Image';

function Meatcuts({meatcut_data, loading, err_data, match}) {
    const [data, setData] = useState(null);
    const [modules, setModules] = useState(0);
    
    let {slug} = match.params;
    let moduleData = {"relatedSlug":slug, "relatedType": "meatcut"};

    useEffect(() => {
        meatcut_data = null;
    }, [])

    useEffect(() => {

		if (loading === false) {
            getMeatcutSync(slug);
        }
        if(!data){
            setData(meatcut_data);
        }
        
		if(meatcut_data && meatcut_data.modules !== null){
            setModules(meatcut_data.modules);
        }
        
    }, [meatcut_data]);

    useEffect(() => {
        //console.log(err_data);
    }, [err_data])
    
    if (loading) {
		return <Loader />
	} else {
        return (
            <Fragment>
                <LoadModules modules={modules} moduleData={moduleData} type="top" />
                {!data && err_data && err_data == '404' &&
                    <NotFound />
                }
                {data &&
                    <Fragment>
                        <Meta
                            title={data.seo_title ? data.seo_title : data.title}
                            description={data.seo_description && data.seo_description}
                            type="website"
                		    image={data.image_url}
                        />
                        <div className="container meatcut__page mt-50 mb-50">
                            <div className="row">
                                <div className="col-12 mb-20">
                                    <h1 className="heading--h1">{data.title && data.title}</h1>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12 col-lg-5 order-lg-1 order-2">
                                    {data.body && parse(data.body)}
                                </div>
                                <div className="col-12 col-lg-6 offset-lg-1 order-lg-2 order-1 meatcut__img">
                                    <Image className="img" src={data.image_url} />
                                </div>
                            </div>
                        </div>
                    </Fragment>
                 }
                 {moduleData &&
                    <LoadModules modules={modules} moduleData={moduleData} type="bottom" />
                 }
          
            </Fragment>
        )
    }
}

export default flatstore.connect(['loading', 'meatcut_data', 'err_data'])(Meatcuts);
